import styled, { css } from 'styled-components';

export const InputField = (disabled?: boolean) => css`
  transition:
    color 0.3s,
    border-color 0.3s,
    background-color 0.3s;

  background-color: rgb(191 191 191);
  border: 1px solid rgb(34 34 34);

  color: rgb(34 34 34);
  border-radius: 5px;
  position: relative;
  letter-spacing: 0;

  line-height: 1rem;
  appearance: none;
  font-size: 1rem;

  display: block;
  padding: 15px;

  outline: none;
  height: 50px;
  width: 100%;

  ${disabled &&
  css`
    background-color: rgb(127 127 127);
    pointer-events: none;
    color: rgb(0 0 0);
  `}

  &:focus,
  &:active {
    background-color: rgb(255 255 255);
    border-color: rgb(0 0 0);
    caret-color: rgb(0 0 0);
    color: rgb(0 0 0);
  }
`;

export const InputPlaceholder = () => css`
  color: rgb(127 127 127);
  line-height: 1rem;
  font-size: 1rem;
  opacity: 0.5;
`;

type FieldContainerAttributes = {
  $last?: boolean;
  width: number;
};

export const FieldContainer = styled.div<FieldContainerAttributes>(
  ({ width, $last }) => css`
    margin-bottom: 1em;
    position: relative;

    width: ${width}%;
    display: block;

    ${$last &&
    css`
      margin-bottom: 0;
    `}
  `
);

export const FieldLabel = styled.label`
  color: rgb(34 34 34);
  font-size: 0.8125rem;
  line-height: 1.5rem;

  margin-bottom: 3px;
  position: relative;

  display: block;
  width: 100%;
`;

export const FieldInput = styled.input(
  ({ disabled }) => css`
    ${InputField(disabled)}

    ::placeholder {
      ${InputPlaceholder()}
    }
  `
);

type FieldErrorAttributes = {
  $margin?: number | string;
};

export const FieldError = styled.span<FieldErrorAttributes>(
  ({ $margin = 5 }) => css`
    margin-top: ${$margin}px;
    font-size: 0.875rem;

    color: rgb(191 0 0);
    position: relative;
    line-height: 1rem;

    display: block;
    width: 100%;
  `
);
